import { useSiteContext, useTranslation } from '@eti/providers';
import { TRAVELER_DETAILS_NO_TRIP } from '../../../constants/dataLayerEventsConstants';
import ErrorDialog from '../../../common/error-modals/ErrorDialog';

interface TravelerDetailsNoTripErrorDialogProps {
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  isOpen: boolean;
}

const TravelerDetailsNoTripErrorDialog = ({
  onPrimaryAction,
  onSecondaryAction,
  isOpen,
}: TravelerDetailsNoTripErrorDialogProps) => {
  const { agencyAccount } = useSiteContext();
  const { t } = useTranslation();

  const conditionalProps = !agencyAccount
    ? {
        onPrimaryAction,
        onSecondaryAction,
        primaryButtonLabel: t('IbeClient.Error.BackToPayment.Btn.Text'),
        secondaryButtonLabel: t('IbeClient.Error.BackToSearch.Btn.Text'),
      }
    : {};

  return (
    <ErrorDialog
      content={t('TravelerDetails.NoTrip.Modal.ContentText')}
      data-testid="noTrip-error-dialog"
      dataLayerEvent={TRAVELER_DETAILS_NO_TRIP}
      isOpen={isOpen}
      title={t('IbeClient.Error.TripNotAvailable.Header')}
      {...conditionalProps}
    />
  );
};

export default TravelerDetailsNoTripErrorDialog;
